import { Skeleton } from '@nextui-org/react'

export function ProductItemLoader() {
  return (
    <div>
      <div className="block">
        <Skeleton>
          <div className="aspect-[3/4] h-full w-full bg-default-300"></div>
        </Skeleton>
        <div className="mt-4 grid grid-cols-1 gap-2">
          <Skeleton className="h-6 w-8/12">
            <div className="h-6 w-8/12 bg-default-300"></div>
          </Skeleton>
          <Skeleton className="h-4 w-4/12">
            <div className="h-4 w-4/12 bg-default-300"></div>
          </Skeleton>
          <div className="mt-2 flex justify-between gap-2">
            <div className="flex items-center gap-1">
              {Array.from({ length: 5 }, (_, i) => (
                <Skeleton className="h-5 w-5" key={i}>
                  <span className="h-5 w-5 bg-default-300"></span>
                </Skeleton>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductItemLoader
